import role from '../helpers/role';

import NewBestlist from '../statistic/NewBestlist.vue';
import ExportBestlist from '../statistic/ExportBestlist.vue';
import Bestlist from '../statistic/Bestlist.vue';


const routes = [{
	path: '/bestlist',
	name: 'bestlist',
	component: Bestlist,
	meta: {
		authorize: [{ name: role.Statistiker }],
	},
}, {
	path: '/newbestlist',
	name: 'newbestlist',
	component: NewBestlist,
	meta: {
		authorize: [{ name: role.Statistiker }],
	},
}, {
	path: '/updatebestlist/:id',
	name: 'updatebestlist',
	component: NewBestlist,
	meta: {
		authorize: [{ name: role.Statistiker }],
	},
}, {
	path: '/exportbestlist/:id',
	name: 'exportbestlist',
	component: ExportBestlist,
	meta: {
		authorize: [{ name: role.Statistiker }],
	},
}, {
	path: '/customDefinitions/:id',
	name: 'customDefinitions',
	component: NewBestlist,
	meta: {
		authorize: [{ name: role.Statistiker }],
	},
}, {
	path: '/customDefinitionsMatrix/:id',
	name: 'customDefinitionsMatrix',
	component: NewBestlist,
	meta: {
		authorize: [{ name: role.Statistiker }],
	},
}, {
	path: '/customDefinitionsValues/:id',
	name: 'customDefinitionsValues',
	component: NewBestlist,
	meta: {
		authorize: [{ name: role.Statistiker }],
	},
}];

export default routes;
